class ReviewManager {
    constructor(options) {
      //console.log('Review Manager Initialized');
      //console.log(options);
      this.inLoad = false;
      this.averageScore = 0;
      this.thePercentage = 0;
      this.totalEls = document.querySelectorAll('.jsReviewsTotalCount');
      this.openReviewsPopup = document.querySelectorAll('.jsReviewWidget');
      this.closeReviewsPopupEls = document.querySelectorAll('.jsReviewOverlay, .jsReviewClose');
      this.loadMore = document.querySelector('.jsLoadMore');
      this.autoLoad = options.autoLoad || false;
      this.place = options.place || 'popup'
      this.limit = options.limit || 5;
    }
  
    YouTubeGetID(ur) {
      ur = ur.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      return ur[2] !== undefined ? ur[2].split(/[^0-9a-z_\-]/i)[0] : ur[0];
    }
  
    loadReviews(index, staticReviews) {
      document.querySelector('.reviews-popup').classList.add('loading');
  
      const theLimit = this.limit + index;

      const staticReviewList = document.querySelector('.jsStaticReviewList');
      const reviewLists = document.querySelectorAll('.jsReviewList');
      const reviewListPopup = document.querySelector('.jsReviewsPopup .jsReviewList');
      const popupReviewsMaxCount = reviews.length;


      let reviewsMaxCount = 0;


      if (staticReviewList &&  window.innerWidth > 480)  {
        reviewsMaxCount = 4;
      } else {
        reviewsMaxCount = 3;
      }

  
      for (var i = index; i < popupReviewsMaxCount; i++) {
        const thePercentage = (reviews[i].score / 5) * 100 + '%';
        const theImage = reviews[i]?.image?.replace(/(\.[^.]*)$/, '_x250$1') || '';
        const theVideo = reviews[i].video;
        const html5video = reviews[i].html5video;
        let reviewText = reviews[i].comment;
  
        // if staticReviews we need to truncate reviewText to 100 characters and show a read more link
  
        if (staticReviews){
          if (reviewText.length > 100){
            reviewText = reviewText.substring(0, 120) + '...';
            // add a read more link
          }
          reviewText += `<a href="/pages/reviews" class="link-red">Read More</a>`;
        }
        //console.log(html5video);
        const hasVideo = theVideo !== undefined && theVideo !== '';
        const theImage2x = reviews[i]?.image?.replace(/(\.[^.]*)$/, '_x250@2x$1') || '';
        let myImage = '';
        if (theImage !== undefined && theImage !== '') {
          myImage = `<img src="${theImage}" srcset="${theImage} 1x, ${theImage2x} 2x">`;
        }
        if (staticReviews){
          myImage = `<div class="reviews-list__image">${myImage}</div>`;
        }
        if (hasVideo || html5video) {
          if (html5video) {
            myImage = `<div class="reviews-list__video">
              <div class="">
                <video width="320" height="240" controls>
                <source src="${html5video}" type="video/mp4">
                Your browser does not support the video tag.
                </video>
              </div>
            </div>`;
          } else {
            const theUrl = this.YouTubeGetID(theVideo);
            myImage = `<div class="reviews-list__video">
              <div class="responsive_video">
                <iframe width="560" height="315" loading="lazy" src="https://www.youtube.com/embed/${theUrl}?controls=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>`;
          }
        }
        const template = `
          <li class="reviews-list__item xx hasVideo_${hasVideo}">
            <div class="reviews-list__header">
              <strong class="reviews-list__title">${reviews[i].title}</strong>
              <span class="reviews-list__star_wrap">
                <span class="reviews-list__star_inner" style="width:${thePercentage}"></span>
              </span>
            </div>
            <div class="reviews-list__meta">
            <span class="reviews-list__name">By ${reviews[i].name}</span>
            <div class="reviews-list__meta__date">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clip-path="url(#clip0_664_2937)">
            <path d="M14.5 16.5H1.5C0.67 16.5 0 15.83 0 15V3C0 2.17 0.67 1.5 1.5 1.5H14.5C15.33 1.5 16 2.17 16 3V15C16 15.83 15.33 16.5 14.5 16.5ZM1.5 2.5C1.22 2.5 1 2.72 1 3V15C1 15.28 1.22 15.5 1.5 15.5H14.5C14.78 15.5 15 15.28 15 15V3C15 2.72 14.78 2.5 14.5 2.5H1.5Z" fill="#71706F"/>
            <path d="M4.5 4.5C4.22 4.5 4 4.28 4 4V1C4 0.72 4.22 0.5 4.5 0.5C4.78 0.5 5 0.72 5 1V4C5 4.28 4.78 4.5 4.5 4.5ZM11.5 4.5C11.22 4.5 11 4.28 11 4V1C11 0.72 11.22 0.5 11.5 0.5C11.78 0.5 12 0.72 12 1V4C12 4.28 11.78 4.5 11.5 4.5ZM15.5 6.5H0.5C0.22 6.5 0 6.28 0 6C0 5.72 0.22 5.5 0.5 5.5H15.5C15.78 5.5 16 5.72 16 6C16 6.28 15.78 6.5 15.5 6.5Z" fill="#71706F"/>
            </g>
            <defs>
            <clipPath id="clip0_664_2937">
            <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
            </defs>
            </svg>
              <span class="reviews-list__meta__date__text">${reviews[i].date}</span>
            </div>
          </div>
            <div class="reviews-list__content">
            ${myImage}
            <div class="reviews-list__text">
              <div class="reviews-list__text__message">
                ${reviewText}        
              </div>
              ${
                reviews[i].response
                  ? `<div class="reviews-list__text__response">
                      <strong>Response from Liberty Trike:</strong> ${reviews[i].response}
                    </div>`
                  : ''
              }
            </div>
            </div>
          </li>`;
       
        reviewLists.forEach(el => el.insertAdjacentHTML('beforeend', template));
        document.querySelector('.reviews-popup').classList.remove('loading');
        if (i === theLimit) {
          this.inLoad = false;
          break;
        }
      }
      for (var i = index; i < reviewsMaxCount; i++) {
        const thePercentage = (reviews[i].score / 5) * 100 + '%';
        const theImage = reviews[i]?.image?.replace(/(\.[^.]*)$/, '_x250$1') || '';
        const theVideo = reviews[i].video;
        const html5video = reviews[i].html5video;
        let reviewText = reviews[i].comment;
  
        // if staticReviews we need to truncate reviewText to 100 characters and show a read more link
  
        if (staticReviews){
          if (reviewText.length > 100){
            reviewText = reviewText.substring(0, 120) + '...';
            // add a read more link
          }
          reviewText += `<a href="/pages/reviews" class="link-red">Read More</a>`;
        }
        //console.log(html5video);
        const hasVideo = theVideo !== undefined && theVideo !== '';
        const theImage2x = reviews[i]?.image?.replace(/(\.[^.]*)$/, '_x250@2x$1') || '';
        let myImage = '';
        if (theImage !== undefined && theImage !== '') {
          myImage = `<img src="${theImage}" alt="Reviews image" srcset="${theImage} 1x, ${theImage2x} 2x">`;
        }
        if (staticReviews){
          myImage = `<div class="reviews-list__image">${myImage}</div>`;
        }
        if (hasVideo || html5video) {
          if (html5video) {
            myImage = `<div class="reviews-list__video">
              <div class="">
                <video width="320" height="240" controls>
                <source src="${html5video}" type="video/mp4">
                Your browser does not support the video tag.
                </video>
              </div>
            </div>`;
          } else {
            const theUrl = this.YouTubeGetID(theVideo);
            myImage = `<div class="reviews-list__video">
              <div class="responsive_video">
                <iframe width="560" height="315" loading="lazy" src="https://www.youtube.com/embed/${theUrl}?controls=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>`;
          }
        }
        const template = `
          <li class="reviews-list__item xx hasVideo_${hasVideo}">
            <div class="reviews-list__header">
              <strong class="reviews-list__title">${reviews[i].title}</strong>
              <span class="reviews-list__star_wrap">
                <span class="reviews-list__star_inner" style="width:${thePercentage}"></span>
              </span>
            </div>
            <div class="reviews-list__meta">
            <span class="reviews-list__name">By ${reviews[i].name}</span>
            <div class="reviews-list__meta__date">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clip-path="url(#clip0_664_2937)">
            <path d="M14.5 16.5H1.5C0.67 16.5 0 15.83 0 15V3C0 2.17 0.67 1.5 1.5 1.5H14.5C15.33 1.5 16 2.17 16 3V15C16 15.83 15.33 16.5 14.5 16.5ZM1.5 2.5C1.22 2.5 1 2.72 1 3V15C1 15.28 1.22 15.5 1.5 15.5H14.5C14.78 15.5 15 15.28 15 15V3C15 2.72 14.78 2.5 14.5 2.5H1.5Z" fill="#71706F"/>
            <path d="M4.5 4.5C4.22 4.5 4 4.28 4 4V1C4 0.72 4.22 0.5 4.5 0.5C4.78 0.5 5 0.72 5 1V4C5 4.28 4.78 4.5 4.5 4.5ZM11.5 4.5C11.22 4.5 11 4.28 11 4V1C11 0.72 11.22 0.5 11.5 0.5C11.78 0.5 12 0.72 12 1V4C12 4.28 11.78 4.5 11.5 4.5ZM15.5 6.5H0.5C0.22 6.5 0 6.28 0 6C0 5.72 0.22 5.5 0.5 5.5H15.5C15.78 5.5 16 5.72 16 6C16 6.28 15.78 6.5 15.5 6.5Z" fill="#71706F"/>
            </g>
            <defs>
            <clipPath id="clip0_664_2937">
            <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
            </defs>
            </svg>
              <span class="reviews-list__meta__date__text">${reviews[i].date}</span>
            </div>
          </div>
            <div class="reviews-list__content">
            ${myImage}
            <div class="reviews-list__text">
              <div class="reviews-list__text__message">
                ${reviewText}        
              </div>
              ${
                reviews[i].response
                  ? `<div class="reviews-list__text__response">
                      <strong>Response from Liberty Trike:</strong> ${reviews[i].response}
                    </div>`
                  : ''
              }
            </div>
            </div>
          </li>`;
       
        staticReviewList?.insertAdjacentHTML('beforeend', template);
        // document.querySelector('.reviews-popup').classList.remove('loading');
        if (i === theLimit) {
          this.inLoad = false;
          break;
        }
      }
      if (i === reviewsMaxCount) {
        document.querySelector('.reviews-popup').classList.remove('loading');
        const loadMore = document.querySelector('.jsLoadMore');
        if (loadMore) {
          loadMore.innerHTML = 'No more reviews to load';
          loadMore.setAttribute('disabled', 'true');
        }
      }
    }
  
    getAverage(reviews) {
      let sum = 0,
        lowScores = 0,
        midScores = 0,
        highScores = 0;
  
      if (!Array.isArray(reviews)) {
        return;
      }
  
      for (let i = 0; i < reviews.length; i++) {
        const that = reviews[i];
        if (that.score) {
          sum += that.score;
          if (that.score >= 4) {
            highScores++;
          } else if (that.score > 2.5 && that.score < 4) {
            midScores++;
          } else {
            lowScores++;
          }
        }
      }
  
      const average = (sum / reviews.length).toFixed(1);
      const thePercentage = (average / 5) * 100;
  
      localStorage.setItem('averageScore', average);
      localStorage.setItem('percentage', thePercentage);
      localStorage.setItem('dataLength', reviews.length);
      return average;
    }
  
    checkForUpdate(length) {
      //console.log(length);
      if (
        length !== localStorage.getItem('dataLength') ||
        !localStorage.getItem('averageScore') ||
        !localStorage.getItem('percentage')
      ) {
        this.averageScore = this.getAverage(reviews);
        this.thePercentage = (this.getAverage(reviews) / 5) * 100;
      } else {
        this.averageScore = localStorage.getItem('averageScore');
        this.thePercentage = localStorage.getItem('percentage');
      }
  
      //console.log(this.averageScore);
      //console.log(this.thePercentage);
    }
  
    showReviewsPopup() {
      document.querySelector('.jsReviewsPopup').style.display = 'block';
      document.querySelector('.jsReviewOverlay').style.display = 'block';
      document.querySelector('.jsReviewsPopup').classList.add('is-open');
      document.querySelector('body').style.overflow = 'hidden';
    }
  
    closeReviewsPopup() {
      document.querySelector('body').style.overflow = 'visible';
      document.querySelector('.jsReviewsPopup').style.display = 'none';
      document.querySelector('.jsReviewOverlay').style.display = 'none';
      document.querySelector('.jsReviewsPopup').classList.remove('is-open');
  
      const videos = document.querySelectorAll('.jsReviewList video');
      videos.forEach((video) => {
        video.pause();
      });
    }
  
    getSiblings(element) {
      let siblings = [];
      let sibling = element.previousElementSibling;
  
      while (sibling) {
        siblings.push(sibling);
        sibling = sibling.previousElementSibling;
      }
  
      return siblings;
    }
  
    setScore(el) {
      document.querySelectorAll('.jsScore').forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          element.classList.add('active');
          document.querySelector('.jsFormScore').value = element.getAttribute('data-score');
        });
  
        element.addEventListener('mouseover', () => {
          this.getSiblings(element).forEach((item) => {
            item.classList.remove('active');
          });
        });
      });
    }
  
    setTotal(){
      //console.log('check if we run it')
      if(this.totalEls){
        // go through the elements and update the total reviews amount
        this.totalEls.forEach((el) => {
          //console.log('go through the elements', el);
          //console.log(reviews)
          el.innerHTML = reviews.length;
        })
      }
    }
  
    openReviewForm() {
      document.querySelectorAll('.jsLeaveReview, .jsCloseReview').forEach((element) => {
        element.addEventListener('click', (event) => {
          event.preventDefault();
          let reviewForm = document.querySelector('.jsReviewForm');
          reviewForm.style.display = reviewForm.style.display === 'none' ? 'block' : 'none';
        });
      });
  
      if (location.hash === '#contact_form') {
        document.querySelector('.jsReviewForm').style.display = 'block';
      }
  
      this.loadReviews(0);
    }
  
    attachEventListeners() {
      if (this.openReviewsPopup) {
        this.openReviewsPopup.forEach((item) => {
          item.addEventListener('click', (event) => {
            event.preventDefault();
            if (!document.querySelector('.jsReviewList li')) {
              this.loadReviews(0);
            }
            this.showReviewsPopup();
          });
        });
      }
  
      if (this.closeReviewsPopupEls) {
        this.closeReviewsPopupEls.forEach((item) => {
          item.addEventListener('click', (event) => {
            event.preventDefault();
            this.closeReviewsPopup();
          });
        });
      }
  
      document.addEventListener('keydown', (event) => {
        //console.log(event.key);
        if (event.key === 'Escape') {
          this.closeReviewsPopup();
        }
      });
  
      if (this.loadMore) {
        this.loadMore.addEventListener('click', (event) => {
          event.preventDefault();
          const currentReviewItems = document.querySelectorAll('.jsReviewList li');
          const index = currentReviewItems.length;
          this.loadReviews(index);
        });
      }
      if (this.autoLoad) {
        let scrollable = document.querySelector('.jsReviewsWrap');
        if (this.place === 'page') {  
          scrollable = window;
        }
        //console.log(scrollable);
        scrollable?.addEventListener('scroll', () => {
          let isLastReviewVisible;
          const reviewsPopup = document.querySelector('.jsReviewsPopup');
          const reviewsList = reviewsPopup.querySelector('.jsReviewList');
          const lastReview = reviewsList.lastElementChild;
          if (this.place === 'popup'){
            isLastReviewVisible = lastReview && lastReview.getBoundingClientRect().bottom <= reviewsPopup.getBoundingClientRect().bottom;
          }
          else {
            isLastReviewVisible = lastReview && lastReview.getBoundingClientRect().bottom <= window.innerHeight;
          }
          if (isLastReviewVisible && !this.inLoad) {
            const currentReviewItems = reviewsList.querySelectorAll('.reviews-list__item');
            const index = currentReviewItems.length;
            this.inLoad = true;
            this.loadReviews(index);
          }
        });
      }
  
    }
  
    init() {
      const length = reviews.length.toString();
  
      this.checkForUpdate(length);
      this.setScore();
      this.setTotal();
  
      if (document.querySelector('.jsReviewForm')) {
        this.openReviewForm();
      }
  
      this.attachEventListeners();
  
      const averageElements = document.querySelectorAll('.jsAverage');
      averageElements.forEach((element) => {
        element.innerHTML = this.averageScore;
      });
  
      const starElements = document.querySelectorAll('.jsStar span');
      starElements.forEach((element) => {
        element.style.width = `${this.thePercentage}%`;
      });
    }
  }
  
  window.addEventListener('DOMContentLoaded', () => {
    const url = window.location.href;
    const reviewManager = new ReviewManager({
      autoLoad: true,
      limit: 1000,
      place: url.indexOf('/pages/reviews') > -1 ? 'page' : 'popup',
    });
    reviewManager.init();
  });
  